// extracted by mini-css-extract-plugin
module.exports = {"list":"styles_list__jPD1y","list-default":"styles_list-default__RUa5X"};